const decorators = {

  // A85 (HT2) has only red color --> disable color topic & force red color
  decorateType: (state, action) => {
    const { payload } = action;
    let { path } = payload;
    if (typeof path === "string") {
      path = path.split("/");
    }
    const [target, prop] = path || [];
    const value = state[target].state[prop];

    if (value === "A85") {
      state.tractor.state.color = "red";
      state.tractor.property.topic.options = state.tractor.property.topic.options.map(
        (topic) =>
          topic.value === "color" ? { ...topic, disabled: true } : topic
      );
    } else {
      state.tractor.property.topic.options = state.tractor.property.topic.options.map(
        (topic) =>
          topic.value === "color" ? { ...topic, disabled: false } : topic
      );
    }
  },
};

export default decorators;
